import { useContext } from 'react';
import { PopperContext } from '../context/Popper';
export function useGetPopper() {
  var _useContext = useContext(PopperContext),
      popper = _useContext.popper;

  if (popper == null) {
    throw new Error('popperContext is not in RcPopper');
  }

  return popper;
}